const { setEnvironment } = require("./client/src/global/environment");
const app = require("./client/src/global/app");
const { getAppName, getSubdomain } = require("./client/src/util/main");
const {
  addBackToDashboard,
  addPopupModal,
  addStyle,
  addScript,
  showUpgradeModal,
  showMaxTokenUpgradeModal,
  showMaxTokenEntUpgradeModal,
  showMaxCreditUpgradeModal,
  validateUser,
  showMonthlyLimitModal,
  showMonthlyLimitEntModal,
  removeImageFlux,
  clearImageFlux
} = require('./client/src/fn');

const init = () => {
  app.aiApp = getSubdomain();
  app.appName = getAppName(app.aiApp);
  addStyle();
  addScript();
  addPopupModal();

  const url = require("./client/src/global/url");
  fetch(`${url.api}/e/get-total-app`, {
    method: 'POST'
  }).then((data) => {
    data.json().then((data)=>{
      app.appTotal = data.total;
    });
  });
  preloadImage(`${url.api}/ext-app/images/bg.png`);
};

const setAppTotal = (total = 0) => {
  app.appTotal = total;
}

const preloadImage = (url = "") => {
  if (!url) return;
  var img=new Image();
  img.src=url;
}

const getUrl = () => {
  const url = require("./client/src/global/url");

  return url;
}

class Aemo {
  init = init;
  addBackToDashboard = addBackToDashboard;
  setAppTotal = setAppTotal;
  setEnvironment = setEnvironment;
  showUpgradeModal = showUpgradeModal;
  showMaxTokenUpgradeModal = showMaxTokenUpgradeModal;
  showMaxTokenEntUpgradeModal = showMaxTokenEntUpgradeModal;
  showMaxCreditUpgradeModal = showMaxCreditUpgradeModal;
  validateUser = validateUser;
  showMonthlyLimitModal = showMonthlyLimitModal;
  getUrl = getUrl;
  removeImageFlux = removeImageFlux;
  clearImageFlux = clearImageFlux;
  showMonthlyLimitEntModal = showMonthlyLimitEntModal;
}

const aemo = new Aemo();

export {
  aemo as default
};